export const meetings = [
  {
    id: "meeting-001",
    type: "technical",
    title: "Архитектурный комитет: миграция на микросервисы",
    date: "2023-04-15T10:00:00",
    participants: [
      { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
      { id: "user-002", name: "Мария Иванова", role: "Senior Backend Developer" },
      { id: "user-003", name: "Сергей Сидоров", role: "DevOps Engineer" },
      { id: "user-004", name: "Екатерина Смирнова", role: "Architect" }
    ],
    summary: {
      title: "Миграция монолита на микросервисную архитектуру",
      content: `Обсуждалась стратегия миграции существующего монолита на микросервисную архитектуру. Основные выводы:
      1. Выделение сервиса авторизации как первый шаг
      2. Использование GraphQL для API Gateway
      3. Docker и Kubernetes для оркестрации
      4. Необходимость обновления CI/CD пайплайнов
      
      Екатерина представила план миграции с разбивкой на 4 этапа. Сергей высказал опасения насчет производительности GraphQL при высоких нагрузках. Мария предложила использовать кэширование для решения потенциальных проблем производительности.`,
      decisions: [
        "Начать с выделения сервиса авторизации",
        "Использовать GraphQL для фасада к микросервисам",
        "Внедрить постепенную миграцию с поддержкой обоих архитектур"
      ],
      actionItems: [
        { action: "Подготовить детальный план миграции авторизации", assignee: "user-002" },
        { action: "Настроить тестовый кластер Kubernetes", assignee: "user-003" },
        { action: "Разработать архитектуру API Gateway", assignee: "user-004" }
      ],
      tags: ["архитектура", "микросервисы", "refactoring", "GraphQL", "Kubernetes"]
    },
    relatedItems: [
      { type: "ticket", id: "ticket-005" },
      { type: "wiki", id: "wiki-002" },
      { type: "meeting", id: "meeting-003" }
    ]
  },
  {
    id: "meeting-002",
    type: "product",
    title: "Приоритизация фич на Q3",
    date: "2023-04-18T14:00:00",
    participants: [
      { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
      { id: "user-006", name: "Ольга Новикова", role: "UX Designer" },
      { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
      { id: "user-007", name: "Дмитрий Волков", role: "Marketing Specialist" }
    ],
    summary: {
      title: "Приоритизация продуктовых фич на 3-й квартал",
      content: `Обсуждение и приоритизация продуктовых задач на третий квартал. Иван представил результаты пользовательских интервью, Ольга показала новые прототипы мобильного интерфейса.
      
      Ключевые выводы:
      1. Мобильное приложение - главный приоритет на квартал
      2. Интеграция с социальными сетями откладывается на Q4
      3. Необходимо улучшить систему рекомендаций на основе ML
      
      Алексей отметил, что команда разработки сможет выполнить не более 70% предложенных задач. Ольга подчеркнула важность проведения A/B тестов для новых элементов интерфейса.`,
      decisions: [
        "Фокус на мобильном приложении в текущем квартале",
        "Приоритизация улучшения рекомендательной системы",
        "Перенос социальных интеграций на следующий квартал"
      ],
      actionItems: [
        { action: "Финализировать прототипы мобильного приложения", assignee: "user-006" },
        { action: "Подготовить план A/B тестирования", assignee: "user-005" },
        { action: "Оценить сроки разработки рекомендательной системы", assignee: "user-001" }
      ],
      tags: ["product", "mobile", "UX", "приоритизация", "Q3", "рекомендации"]
    },
    relatedItems: [
      { type: "ticket", id: "ticket-008" },
      { type: "ticket", id: "ticket-010" },
      { type: "wiki", id: "wiki-004" }
    ]
  },
  {
    id: "meeting-003",
    type: "technical",
    title: "Оптимизация производительности фронтенда",
    date: "2023-04-10T11:30:00",
    participants: [
      { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
      { id: "user-008", name: "Наталья Козлова", role: "Frontend Developer" },
      { id: "user-009", name: "Андрей Соколов", role: "Performance Engineer" }
    ],
    summary: {
      title: "Стратегия оптимизации производительности фронтенда",
      content: `Обсуждение текущих проблем с производительностью фронтенда и план оптимизации. Андрей представил результаты профилирования и выявил ключевые проблемные места:
      
      1. Медленная загрузка начальной страницы (>3сек)
      2. Неоптимальная обработка изображений
      3. Излишние запросы к бэкенду
      
      Наталья предложила перейти на Server Components и применить стратегии code-splitting. Также обсудили возможность внедрения Service Worker для кэширования.
      
      Согласились на первичную оптимизацию критического пути рендеринга и внедрение ленивой загрузки компонентов за пределами вьюпорта.`,
      decisions: [
        "Внедрить code-splitting и ленивую загрузку компонентов",
        "Оптимизировать изображения с использованием CDN",
        "Внедрить мониторинг Core Web Vitals в Production"
      ],
      actionItems: [
        { action: "Настроить code-splitting в проекте", assignee: "user-008" },
        { action: "Интегрировать систему мониторинга производительности", assignee: "user-009" },
        { action: "Оптимизировать критический CSS", assignee: "user-008" }
      ],
      tags: ["performance", "frontend", "оптимизация", "code-splitting", "web vitals"]
    },
    relatedItems: [
      { type: "ticket", id: "ticket-003" },
      { type: "wiki", id: "wiki-005" },
      { type: "meeting", id: "meeting-001" }
    ]
  },
  {
    id: "meeting-004",
    type: "organizational",
    title: "Реорганизация команды разработки",
    date: "2023-04-20T09:00:00",
    participants: [
      { id: "user-010", name: "Максим Белов", role: "CTO" },
      { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
      { id: "user-011", name: "Елена Павлова", role: "HR Manager" },
      { id: "user-012", name: "Владимир Никитин", role: "Head of Engineering" }
    ],
    summary: {
      title: "План реорганизации команды разработки",
      content: `Обсуждение новой структуры команды разработки в связи с ростом продукта и увеличением штата. Владимир представил новую схему с разделением на 3 основные команды:
      
      1. Команда фронтенд-разработки
      2. Команда бэкенд-сервисов
      3. DevOps и инфраструктура
      
      Елена подняла вопрос о процессе перехода и коммуникации изменений. Алексей выразил опасения о потенциальных проблемах с кросс-командной коммуникацией.
      
      Максим предложил внедрить методологию Spotify (squads и chapters) для сохранения гибкости и улучшения экспертизы. 
      
      Решили начать с пилотного периода для оценки эффективности новой структуры.`,
      decisions: [
        "Разделить команду на 3 направления с выделенными лидами",
        "Внедрить элементы модели Spotify для организации работы",
        "Провести пилотный период в течение 2 месяцев"
      ],
      actionItems: [
        { action: "Подготовить детальный план реорганизации", assignee: "user-012" },
        { action: "Разработать новые процессы коммуникации", assignee: "user-011" },
        { action: "Подготовить презентацию для всей команды", assignee: "user-010" }
      ],
      tags: ["организация", "команда", "структура", "методология", "Spotify", "agile"]
    },
    relatedItems: [
      { type: "wiki", id: "wiki-001" },
      { type: "meeting", id: "meeting-007" },
      { type: "ticket", id: "ticket-012" }
    ]
  },
  {
    id: "meeting-005",
    type: "product",
    title: "Анализ метрик использования мобильного приложения",
    date: "2023-04-25T15:00:00",
    participants: [
      { id: "user-005", name: "Иван Кузнецов", role: "Product Manager" },
      { id: "user-007", name: "Дмитрий Волков", role: "Marketing Specialist" },
      { id: "user-013", name: "Анна Морозова", role: "Data Analyst" },
      { id: "user-014", name: "Геннадий Захаров", role: "Mobile Developer" }
    ],
    summary: {
      title: "Анализ пользовательских метрик мобильного приложения",
      content: `Анализ пользовательских метрик мобильного приложения за последний квартал. Анна представила подробный анализ воронки конверсии и точек выхода пользователей.
      
      Ключевые выводы:
      1. Высокий процент отказа на экране регистрации (47%)
      2. Низкий показатель возвращения пользователей (<30%)
      3. Высокая вовлеченность у активных пользователей (>35 мин/день)
      
      Геннадий отметил технические проблемы с производительностью на устройствах среднего сегмента. Дмитрий поделился результатами последних маркетинговых кампаний и предложил скорректировать таргетирование.
      
      Решили сосредоточиться на упрощении процесса регистрации и улучшении удержания пользователей.`,
      decisions: [
        "Упростить процесс регистрации и внедрить вход через соцсети",
        "Разработать стратегию уведомлений для возврата пользователей",
        "Оптимизировать производительность на устройствах среднего сегмента"
      ],
      actionItems: [
        { action: "Редизайн экрана регистрации", assignee: "user-006" },
        { action: "Разработать систему умных уведомлений", assignee: "user-005" },
        { action: "Профилирование и оптимизация производительности", assignee: "user-014" }
      ],
      tags: ["mobile", "метрики", "аналитика", "конверсия", "удержание", "оптимизация"]
    },
    relatedItems: [
      { type: "ticket", id: "ticket-009" },
      { type: "ticket", id: "ticket-011" },
      { type: "wiki", id: "wiki-004" }
    ]
  },
  {
    id: "meeting-006",
    type: "technical",
    title: "Код-ревью API платежной системы",
    date: "2023-04-28T13:00:00",
    participants: [
      { id: "user-002", name: "Мария Иванова", role: "Senior Backend Developer" },
      { id: "user-015", name: "Павел Соловьев", role: "Security Engineer" },
      { id: "user-016", name: "Кирилл Орлов", role: "Payment Systems Specialist" }
    ],
    summary: {
      title: "Результаты код-ревью API платежной системы",
      content: `Детальное обсуждение результатов код-ревью новой версии API платежной системы. Павел провел аудит безопасности и выявил несколько критических уязвимостей:
      
      1. Недостаточная валидация входных данных
      2. Отсутствие проверки CSRF-токенов
      3. Проблемы с шифрованием данных карт
      
      Кирилл представил анализ соответствия требованиям PCI DSS и отметил необходимость дополнительных мер для полного соответствия стандарту.
      
      Мария предложила ряд архитектурных изменений для повышения отказоустойчивости системы и упрощения масштабирования.`,
      decisions: [
        "Доработать систему валидации с использованием JSON Schema",
        "Внедрить дополнительные меры защиты согласно OWASP Top 10",
        "Провести внешний аудит безопасности перед релизом"
      ],
      actionItems: [
        { action: "Реализовать валидацию на основе JSON Schema", assignee: "user-002" },
        { action: "Подготовить чеклист для соответствия PCI DSS", assignee: "user-016" },
        { action: "Организовать внешний аудит безопасности", assignee: "user-015" }
      ],
      tags: ["security", "payment", "API", "PCI DSS", "код-ревью", "безопасность"]
    },
    relatedItems: [
      { type: "ticket", id: "ticket-001" },
      { type: "ticket", id: "ticket-006" },
      { type: "wiki", id: "wiki-007" }
    ]
  },
  {
    id: "meeting-007",
    type: "organizational",
    title: "Обсуждение процесса онбординга",
    date: "2023-04-05T10:00:00",
    participants: [
      { id: "user-011", name: "Елена Павлова", role: "HR Manager" },
      { id: "user-001", name: "Алексей Петров", role: "Tech Lead" },
      { id: "user-017", name: "Игорь Васильев", role: "Junior Developer" }
    ],
    summary: {
      title: "Улучшение процесса онбординга новых сотрудников",
      content: `Обсуждение текущего процесса онбординга и предложения по его улучшению. Игорь, недавно прошедший процесс, поделился своим опытом и выделил основные проблемы:
      
      1. Отсутствие четкой программы на первые 2 недели
      2. Недостаточная документация для новичков
      3. Отсутствие выделенного ментора
      
      Елена представила исследование успешных практик онбординга в других компаниях. Алексей поделился опытом внедрения "легких задач" для быстрого погружения в проект.
      
      Решили разработать структурированную программу с выделенным ментором и четким планом на первый месяц.`,
      decisions: [
        "Создать программу онбординга с детальным планом на первый месяц",
        "Внедрить систему менторства для новых сотрудников",
        "Разработать набор стартовых задач для быстрого вхождения в проект"
      ],
      actionItems: [
        { action: "Разработать структуру программы онбординга", assignee: "user-011" },
        { action: "Подготовить базу знаний для новых сотрудников", assignee: "user-001" },
        { action: "Сформировать набор стартовых задач для разных ролей", assignee: "user-001" }
      ],
      tags: ["onboarding", "hr", "менторство", "документация", "процессы"]
    },
    relatedItems: [
      { type: "wiki", id: "wiki-001" },
      { type: "meeting", id: "meeting-004" },
      { type: "ticket", id: "ticket-007" }
    ]
  }
]; 